/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { memo, useState } from "react";
import UserSettingModal from "../models/UserSettingModal";
import { MenuIcon } from "../../assets/icons/svg";

const UserSetting = ({ selectedLanguage }) => {
  const [show, setShow] = useState(false);
  const [settingType, setSettingType] = useState(false);

  const settingOpen = () => {
    setShow(true);
    setSettingType("type");
  };

  const handleClose = () => {
    setShow(false);
  };

  const userSettingModalProps = {
    show,
    settingType,
    setSettingType,
    handleClose,
    selectedLanguage,
  };

  return (
    <>
      <span
        className="alink three-dot icon_container m-0"
        onClick={() => settingOpen()}
      >
        <MenuIcon width={14} height={14} />
      </span>
      {show && <UserSettingModal {...userSettingModalProps} />}
    </>
  );
};

export default memo(UserSetting);
